import moment from 'moment';

export const getDaysInMonth = (date: Date | string): number => {
    return moment(date, 'YYYY-MM').daysInMonth();
};
